import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { Header } from "semantic-ui-react"
import * as css from "./SectionHeader.module.less"

function SectionHeader({
  title,
  subtitle,
  label,
  cta,
  children,
  level,
  size,
  centered,
  bordered,
  decorated,
  contrasted,
  inverted,
  narrow,
  constrained,
  margin,
  marginTop,
  className,
}) {
  let textSize = size
  const hero = textSize === "hero"
  const post = textSize === "post"

  if (textSize === "hero" || textSize === "post" || level === "h1") {
    textSize = "huge"
  }

  const classNames = cx(
    css.header,
    {
      [css.centered]: !!centered,
      [css.bordered]: !!bordered,
      [css.constrained]: !!constrained,
      [css.margin]: !!margin,
      [css.marginTop]: !!marginTop,
      [css.marginLight]: margin === "light",
      [css.marginExtraLight]: margin === "extraLight",
      [css.hero]: hero,
      [css.post]: post,
      [css.inverted]: !!inverted,
      [css.narrow]: !!narrow,
    },
    className
  )

  return (
    <Header as={level} size={textSize} className={classNames}>
      {label && (
        <div
          className={cx(css.label, {
            [css.labelDecorated]: decorated,
          })}
        >
          {label}
        </div>
      )}
      {title || children}
      {subtitle && (
        <Header.Subheader
          className={cx(css.subtitle, {
            [css.subtitleHuge]: textSize === "huge" || textSize === "large",
            [css.subtitleContrasted]: !!contrasted,
          })}
        >
          {subtitle}
        </Header.Subheader>
      )}
      {cta && <div className={css.cta}>{cta}</div>}
    </Header>
  )
}

SectionHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Small text that appears above the title */
  label: PropTypes.string,
  /** Used to specify the header level for SEO / styling purposes */
  level: PropTypes.oneOf(["h1", "h2", "h3"]),
  /** CTA to include after the subtitle */
  cta: PropTypes.node,
  /** Used to change the visual size of the header, independent of the header level */
  size: PropTypes.string,
  /** If set, this will replace the `title` prop */
  children: PropTypes.node,
  /** If true, center the text */
  centered: PropTypes.bool,
  /** If true, limit section width */
  constrained: PropTypes.bool,
  /** If true, add left border and remove label line */
  bordered: PropTypes.bool,
  /** If true, set light color to subtitle text */
  contrasted: PropTypes.bool,
  /** If true, add a line decoration to the label */
  decorated: PropTypes.bool,
  /** If true, invert text colors to adapt a dark background */
  inverted: PropTypes.bool,
  /** If true, remove margin among text elements */
  narrow: PropTypes.bool,
  /** If true, add margin below. Can also be specified as "light" */
  margin: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Additional className(s) */
  className: PropTypes.string,
}

SectionHeader.defaultProps = {
  level: "h2",
}

export default SectionHeader
